<template>
  <div id="move-wild-game-modal" tabindex="-1" aria-hidden="true" data-modal-backdrop="static" 
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full">
    <div class="relative w-full   max-w-3xl  ">
      <!-- Modal content -->
      <div class=" relative pt-4 pb-2 bg-gray-200 rounded-lg shadow   flex flex-col  items-stretch   ">
        <!-- Modal header -->
        <div
          class="  px-4 flex items-center justify-between pb-1 mb-2 border-b border-gray-200 rounded-t sm:mb-5 ">
          <h3 class="text-left left font-semibold text-gray-900 text-lg ">
            <h5 class="font-semibold text-gray-900 text-lg ">
              <span class="">Gibier</span> <span class="italic text-gray-700">{{input.name}} : {{input.number}}</span>
            </h5>
            <h5 v-if=" input.action == 'move-game-batch-2'"
              class="  font-semibold text-gray-900 text-lg ">
              <span class=" ">Lot actuel :</span> <span class="italic text-gray-700">{{input.source.name}}</span>
            </h5>
            <h5 v-if=" input.action == 'move-game-delivery-2'"
              class="hidden  font-semibold text-gray-900 text-lg ">
              <span class=" ">Bon d'Arrivage actuel :</span> <span class="italic text-gray-700">{{input.source}}</span>
            </h5>
            <h5 v-if=" input.action == 'move-game-pickup-3'"
              class="  font-semibold text-gray-900 text-lg ">
              <span class=" ">Bon de Collecte :</span> <span class="italic text-gray-700">{{input.source}}</span>
            </h5>
          </h3>

          <button type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click=" onClose()">
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>




        <div class=" flex items-stretch bg-white  rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">


          <div class="w-full  h-full pr-2">
            <p class="text-base font-bold text-left text-gray-500  mb-4">
           <span  v-if=" input.action == 'move-game-batch-2'">Veuillez choisir le nouveau Lot pour ce Gibier</span>
           <span  v-if=" input.action == 'move-game-delivery-2'">Veuillez choisir le nouveau Bon pour ce Gibier</span>
           <span  v-if=" input.action == 'move-game-pickup-3'">Veuillez choisir le nouveau Bon pour ce Gibier</span>
            </p>
            <form class="flex items-center   mx-2 flex flex-col w-full items-center justify-start">
         
              <label for="simple-search" class="sr-only">Rechercher</label>
              <div class="relative w-full">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 " aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5v10M3 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V6a3 3 0 0 0-3-3H9m1.5-2-2 2 2 2" />
                  </svg>
                </div>
                <input @keyup="onChange" v-model="query" type="text" id="simple-search"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5       "
                  placeholder="Rechercher par numéro, nom ou reference du chasseur" required />
              </div>

            </form>

            <div class="w-full bg-orange-200  ml-2 mr-4 text-left justify-left relative mt-3">
              <div
                class="flex flex-col w-full pr-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg     h-96 overflow-y-auto">
                <button v-for="item in filtered_items" :key="item.id" type="button" @click="onSelect(item)"
                class="flex flex-row justify-left items-center w-full px-4 py-2 font-medium text-left   border-b border-gray-200 cursor-pointer hover:bg-blue-500 hover:text-white focus:outline-none  focus:font-bold focus:ring-2 focus:ring-blue-700 focus:text-white focus:bg-blue-700     "
                  
                :class="{ 'text-white bg-blue-700': (selected != undefined && item?.id === selected?.id) , 'text-gray-900 bg-white': item?.id != selected?.id }"
             
                  
                  
                  
                  >
                  <div class="left text-left w-48 justify-left truncate   ">
                    {{item.done_at}}
                  </div>
                  <div class="left text-left  w-64 justify-left truncate  px-3">
                    {{item.name}}
                  </div>
                  <div class="right truncate w-36  px-3">
                    {{item.hunter_number}}
                  </div>
                  <div class="right truncate w-full px-3">
                    {{item.hunter_name.toUpperCase()}}
                  </div>

                </button>
              </div>
            </div>
          </div>
        </div>


     
          <div class="flex items-center justify-between px-4  ">
            <div class="text-gray-500 italic text-xs">
              *720* 
            </div>
            <div class="flex items-center justify-end">
           
          <button type="button"
            class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
            @click="onClose()">
            Annuler
          </button>
          <button type="button"
            class="inline-flex items-center text-white focus:ring-4 focus:outline-none focus:ring-gray-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center  "
            :disabled="selected==undefined"
            :class="{' bg-gray-600 hover:bg-gray-700':selected != undefined,' bg-gray-400 hover:bg-gray-400': (selected == undefined)}"
            @click="onValidate">
             
            DEPLACER VERS CE BON 
          </button>
        </div></div>


      </div>
    </div>
  </div>
</template>

<script>
  import labels from "@/assets/lg/attribut.json"
  import service from "@/services/FullService.vue"



  import { mapGetters } from "vuex";


  export default {
    name: 'WildGameMoveModal',
    props: {
      input: Object
    },
    computed: {
      ...mapGetters({ user: "StateUser" }),
      isLoggedIn: function () {
        return this.$store.getters.isAuthenticated;
      },
    },
    data() {
      return ({
        lg: "FR",
        labels: labels,
        price: "",
        mode: "",
        id: null,
        items: [],
        selected: null,
        filtered_items: [],
        query: ""
      })
    },
    watch: {
      'input': async function () {
        this.id = this.input?.id
        this.source = this.input?.source

        this.loadBatches()

      }
    },
    async mounted() {
      this.id = this.input?.id
      this.source = this.input?.source
    },

    methods: {

      onChange() {
        //filtered_items

        let q = this.query
        this.filtered_items = this.items.filter(function (a) {

          return ((a.hunter_number.indexOf(q) != -1) || (a.hunter_name.indexOf(q) != -1) || (a.name.indexOf(q) != -1))

        })
      },

      displayDate(d) {
        if (d == undefined) return ""
        let s = d.split("T")

        let ss = s[0].split("-")

        return ss[2] + "/" + ss[1] + "/" + ss[0]
      },
      async loadBatches() {
        // let id = "661bf932f79d5093e35014f2" version 1

        //   let id = "675eeb0b631f5e8528e0767d" // Liste des Delivery reports, a refaire

        let id = ""  // Collecte
        //let id = "67cc280fc9ca06863bc465e9"


        if (this.input.action == 'move-game-pickup-3') {
          id = "67b9e8783c82b4f8d32147d5"
        }
        if (this.input.action == 'move-game-delivery-2') {
          id = "67cc280fc9ca06863bc465e9"
        }

        if (this.input.action == 'move-game-batch-2') {
          id = "67cc280fc9ca06863bc465e9" // Arvoir
        }



        let records = await service.getData("data-sources/" + id + '/records', this.user?.token, Object.assign({ limit: 10000, offset: 0, entity_id: this.input.entity_id }))

        let items = []
    
        for (let i = 0; i < records.records.length; i++) {
          if (this.input.source != records.records[i].number)
            items.push({ id: records.records[i]._id, name: records.records[i].number, done_at: this.displayDate(records.records[i].done_at), hunter_name: records.records[i]?.company_name, hunter_number: records?.records[i]?.company_reference })
        }
        this.items = items
        this.filtered_items = items
        this.query = ""
      },
      onSelect(id) {
        this.selected = id
      },

      onValidate() {

        let item =
        {
          id: this.input.id,
          action: this.input.action,
          source: { id: this.input.record_id },
          target: { id: this.selected },

        }

        this.$emit("confirm", item)
        // this.name = ""
      },
      onClose() {
        this.$emit("close")

      }
    },
    components: {

    },
  }
</script>